import dataService from 'services/dataService';
import {
  apiDoctorInteractiveTime,
  INTERACTIVE_TIME_CSV_REPORT,
} from 'services/dataService/resources';

const ITEMS_PER_PAGE = 100;

const INITIAL_STATE = {
  page: 1,
  itemsPerPage: ITEMS_PER_PAGE,
  totalPages: 0,
  totalCount: 0,
  dates: [],
  interactiveTime: [],
};

const interactiveTime = {
  state: INITIAL_STATE,
  reducers: {
    setInteractiveTime: (state, payload) => ({
      ...state,
      interactiveTime: payload,
    }),
    setPage: (state, payload) => ({
      ...state,
      page: payload < 1 ? 1 : payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    setDates: (state, payload) => ({
      ...state,
      dates: payload,
    }),
  },
  effects: (dispatch) => ({
    async getInteractiveReport(payload, state) {
      const { page, itemsPerPage, dates } = state.interactiveTime;
      const [startTime, endTime] = dates;

      const { data } = await dataService.getList(
        apiDoctorInteractiveTime(itemsPerPage, page, startTime, endTime),
      );
      if (data) {
        dispatch.interactiveTime.setInteractiveTime(data?.data || []);
        const totalCount = data?.count || 0;
        const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
        dispatch.interactiveTime.setTotalCountAndTotalPages({
          totalCount,
          totalPages,
        });
      }
    },
    async setPageInteractiveTime({ pageOffset }, state) {
      const { page, totalPages } = state.interactiveTime;
      const newPage = page + pageOffset;
      dispatch.interactiveTime.setPage(
        newPage <= totalPages ? newPage : totalPages,
      );

      return dispatch.interactiveTime.getInteractiveReport();
    },
    async setDatesInteractiveTime({ newDates }) {
      if (newDates.length === 0) {
        dispatch.interactiveTime.setDates([]);
      } else {
        const dateTimes = [newDates[0].getTime(), newDates[1].getTime()];
        dispatch.interactiveTime.setDates(dateTimes);
        dispatch.interactiveTime.setPage(1);
        return dispatch.interactiveTime.getInteractiveReport();
      }
    },
    async getInteractiveCsvReport(payload, state) {
      const { dates } = state.interactiveTime;
      const [startTime, endTime] = dates;

      const { error, data } = await dataService.createOne(
        INTERACTIVE_TIME_CSV_REPORT,
        {
          startTime,
          endTime,
        },
      );
      return { error, data };
    },
  }),
};

export default interactiveTime;
